import React from 'react';
import PopupSelect from 'src/components/complex/popupSelect';
import { addressObject } from 'src/helpers';

const HospitalSelect = ({ value, onChange, name, apiConfig = {}, ...props }) => {
  const normalizedValue = value === '' ? null : value;

  return (
    <PopupSelect
      placeholder={'Location'}
      template={5}
      isPopover={true}
      defaultValue={false}
      apiConfig={{
        url: '/hospital/list',
        labelFn: (item) => (
          <div className={'mc-flex-0-col'} style={{ whiteSpace: 'normal' }}>
            <div className={'mc-text-518'}>{item.hospital?.split('_')[0]}</div>
            <div className={'mc-label-416'}>
              {
                addressObject({
                  cityAddress: item.city,
                  stateAddress: item.state,
                  countryAddress: item.country
                }).fullAddressNameReverse
              }
            </div>
          </div>
        ),
        ...apiConfig
      }}
      selectedLabelFn={(item) => (
        <div className={`mc-text-418 mc-grow  mc-pointer mc-text-truncate`} style={{ minWidth: 0 }}>
          {item.hospital?.split('_')[0]}{' '}
          {item.city &&
            ' (' +
              addressObject({
                cityAddress: item.city,
                stateAddress: item.state,
                countryAddress: item.country
              }).fullAddressNameReverse +
              ')'}
        </div>
      )}
      initSelectedParamKey={normalizedValue ? (selectedValue) => ({ hospitalIds: [selectedValue] }) : undefined}
      name={name}
      value={normalizedValue}
      onChange={onChange}
      {...props}
    />
  );
};

HospitalSelect.displayName = 'HospitalSelect';

export default HospitalSelect;
